import React, { lazy, useEffect, useState } from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { themeChange } from 'theme-change'
import checkAuth from './app/auth';
import initializeApp from './app/init';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './app/store';


// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))


// Initializing different libraries
initializeApp()

function App() {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false)
    
    // Initialize auth after component mounts to ensure Redux store is ready
    const token = checkAuth();
    setIsAuthReady(true);
  }, [])


  return (
    <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* Place new routes over this */}
          <Route path="/app/*" element={<Layout />} />

          <Route path="*" element={<Navigate to={localStorage.getItem('token') ? "/app/welcome" : "/login"} replace />}/>

        </Routes>
      </Router>
      </PersistGate>
    </Provider>
    </>
  )
}

export default App
